<template>
  <v-main class="page-ticket page-ticket-select">
    <v-overlay absolute :value="isLoading">
       <v-progress-circular
           indeterminate
           size="24"
       />
    </v-overlay>
    <AppBar>
      <template #start>
        <v-btn icon plain :ripple="false" @click="goPage()">
          <IconBack/>
        </v-btn>
      </template>
    </AppBar>

    <v-layout fill-height column>
      <v-container fluid flex-fill>

        <div class="ticket-title-block">
          <h3 class="tit" v-html="info.text"></h3>
        </div>

        <div class="ticket-desc-block">
          <v-btn block depressed :ripple="false"
                 class="btn-see-ticket btn-animation"
                 @click="ticketInfo();">
            일반관리·집중관리에 대해 알아보아요!
            <v-spacer/>
            <i class="ez-dms-arr-right-md"></i>
          </v-btn>
          <ul class="list dot dot-sm mt-4" v-show="info.visible">
            <!--            <li>티켓은 <b class="primary&#45;&#45;text">선착순으로</b> 발급됩니다.</li>-->
            <li>티켓 발급 등에 관한 내용은 기업 담당자에게 문의하세요.</li>
            <li>가이드와 찐한대화 일정 선택 완료 후 마음여행이 시작됩니다.</li>
            <li>집중관리를 시작하면 여행지원서를 재작성할 수 없습니다.</li>
          </ul>
        </div>

        <!-- 보유중 티켓이 없을경우 -->
        <article v-if="ticketList.length === 0" class="ticket-list no-data">
          <div class="no-data-text">
            현재 보유 중인 티켓이 없습니다.
          </div>
        </article>
        <!-- 티켓 리스트 -->
        <article v-else class="ticket-list">
          <div v-for="n in ticketList.length" :key="n"
               class="ticket-list-item"
               :class="{ 'ticket-list-item--active' : current === n }"
          >
            <div class="ticket">
              <div class="ticket-info">
                <div class="date">
                  {{ '~ '+ticketList[n - 1].validperiodEndDt }}
                </div>
                <div class="name">
                  <img :src="getImage('ic_keep.svg')" class="">
                  {{ ticketList[n - 1].ticketName }}
                </div>
                <div class="desc">
                  {{ ticketList[n - 1].dscrt }}
                </div>
                <v-chip small color="primaryLight" text-color="primary" class="py-2 mt-2">
                  <template v-if="info.visible">
                    선착순
                    <v-divider vertical class="mx-2"/>
                  </template>
                  <b>잔여 {{ ticketList[n - 1].remainCnt }}</b>
                </v-chip>
              </div>
              <div class="ticket-state">
                <v-btn text :ripple="false"
                       class="btn-ticket-state"
                       :class="{ 'btn-ticket-state--active' : current === n }"
                       @click="ticketSelect(n);"
                >
                  {{ ticketList[n - 1].ticketState === '03' ? '선택' : '대기' }}
                </v-btn>
              </div>
            </div>
          </div>
        </article>

      </v-container>
      <v-footer app fixed grow color="white" class="content-footer">
        <div class="footer-btns">
          <BlackBtn x-large str="시작하기" :disabled="btnDisable || isLoading" @click="ticketStart();"></BlackBtn>
          <v-btn color="primary" class="btn-plain"
                 x-large depressed
                 @click="$root.movePage('/')">
            일반관리 먼저 할게요.
          </v-btn>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>

<script>
import store from '@/store'
import {mixinAuth, mixinTicket} from '@/mixins'
import IconBack from "@/components/icons/Back"
import BlackBtn from "@/components/btns/BlackBtn"

export default {
  components: {
    IconBack,
    BlackBtn,
  },
  mixins: [mixinAuth, mixinTicket],
  data: () => ({
    isSelect: false,
    btnDisable: true,
    ticketList: [],
    current: 0,
    usePsbYn: '',
    remainCnt: 0,
    first: '',
    weatherStatus: null,
    isLoading: false
  }),
  computed: {
    info() {
      if (this.isSamsungFire) {
        return {
          text: `<span class="primary--text">맞춤형 집중관리 티켓</span>이<br /> 추천되었어요!`,
          visible: true
        }
      } else {
        return {
          text: `티켓을 선택하고<br /><b>여행을 시작해보세요.</b>`,
          visible: false
        }
      }
    }
  },
  created() {
    //안내문구
    // this.infoTextSet()
    this.first = this.$route.query.first;
  },
  mounted() {
    // 티켓 선택 후 가이드 및 찐한대화 일정 미입력 여부
    this.getUseOrdDtlNoGuide()
    // 삼성 티켓 체크 API
    this.getFireTicketCheck()
    //유저 삼성 티켓 리스트 API
    this.getFireTicketList()
    //여행지원서 마음날씨 조회
    this.getMemberApplResultLast()
  },
  methods: {
    ticketSelect(n) {
      this.remainCnt = this.ticketList[n - 1].remainCnt
      if (this.ticketList[n - 1].ticketState === '03') {
        if (this.remainCnt <= 0) {
          //this.$alert('집중관리(상담) 받을 수 있는</br> 기회가 선착순으로 마감되었습니다.</br> 기업체 담당자에게 문의해 주세요.').then(result => {if (result) this.movePage('/');})
        } else {
          this.current = n
          this.btnDisable = false
        }
      }
    },
    ticketCheck(useYn) {
      if (this.usePsbYn == 'N') { //유효기간 D-85일 이하 이면 사용 불가 가용가능(Y), 불가능(N)
        this.$alert(`집중관리(상담) 티켓은 서비스 종료 전</br> 3개월까지만 발급 가능합니다.</br> 기업체 담당자에게 문의해주세요.`).then(result => {if (result) this.movePage('/');})
      } else if (this.weatherStatus.stateCd == '01') {
        this.$alert(`마음날씨가 <span class="primary--text">'쨍쨍'</span>인 경우,</br> 집중관리(상담)가 진행되지 않습니다.</br> 집중관리(상담)가 필요한 경우가 생기면,</br> 다시 여행 지원서를 작성해 보세요.`).then(result => {if (result) this.movePage('/');})
      } else if (this.remainCnt <= 0) {
        this.$alert(`집중관리(상담) 받을 수 있는</br> 기회가 선착순으로 마감되었습니다.</br> 기업체 담당자에게 문의해 주세요.`).then(result => {if (result) this.movePage('/');})
      } else {
        if (useYn == 'Y') {
          this.$confirm('집중관리를 시작하시겠어요?<br>찐한 대화 일정 선택까지 완료하셔야 집중 관리가 시작됩니다.', {
            persistent: false,
            showClose: true,
            actions: {
              false: {text: '아니오'},
              true: {text: '예'}
            }
          }).then(result => {
            if (result) {
              //티켓 사용
              this.insertUserSolution(this.ticketList[this.current - 1]) // 솔루션 매핑 후 -> 티켓 사용처리 로직 수정
            }
          })
        }
      }

    },
    ticketStart() {
      //여행 시작하기 전 다시체크
      //this.getFireTicketCheck('Y')
      this.ticketCheck('Y')
      //TODO EZN 개발진행 시 재결제 변경,유지 모달창 추가예정
      //this.movePage('/user/fo/guideSelect?m=1');
    },
    async getFireTicketCheck() {  // 유저 삼성 티켓 체크 API
      await store.dispatch('getFireTicketCheck')
        .then(res => {
          if (res.success) {
            this.usePsbYn = res.data.usePsbYn
            this.remainCnt = res.data.remainCnt
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
          this.usePsbYn = 'N'
          this.remainCnt = 0
        })
        .finally(() => {
          //this.ticketCheck()
        })
    },
    async getMemberApplResultLast() { // 여행지원서 마지막 결과 확인
      await store.dispatch('getMemberApplResultLast', this.$_payload('so', [{'travelApplNo': 1}]))
        .then(res => {
          if (res.success) {
            if (res.data != null) {
              this.getApplResultForWeatherStatus(res.data);
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch(() => {
        })
        .finally(() => {
          store.commit('setInitApplResult', false)
        })
    },
    async getApplResultForWeatherStatus(so) {  // 여행지원서 마음날씨 구분 값 조회 Api
      await store.dispatch('getApplResultForWeatherStatus', this.$_payload('so', [
        {'travelApplNo': so.travelApplNo},
        {'unitNo': so.unitNo},
        {'travelApplStepCd': so.travelApplStepCd},
        {'memberStepApplCnt': so.memberStepApplCnt},
        {'memberNo': so.memberNo},
        {'areaCritType': '01'},
        {'areaCrit': '00'},
      ]))
        .then(res => {
          if (res.success) {
            //this.weatherUrl = res.data.imgPath;
            this.weatherStatus = res.data
          } else {
            console.log(res.msg)
            this.weatherStatus = null
          }
        })
        .catch(error => {
          console.error(error)
          this.state = "";
        })
        .finally(() => {
          this.ticketCheck()
        })
    },
    async insertUserSolution (ticketList) {
        this.isLoading = true
        await store.dispatch('insertUserSolution', this.$_payload('ticketUserPo', ticketList))
            .then(async res => {
              if (res.success) {
                const { allowsRealtalkService, goodsNo }  = res.data;
                store.commit('setContract', {
                  ...store.state.client.contract,
                  allowsRealtalkService,
                  goodsNo
                })
                const url = store.state.client.contract.allowsRealtalkService ? '/fo/guideSelect?m=1' :'/fo/intro';

                this.movePage(url);
              } else {
                this.$alert(res.msg).then(result => {if (result) this.movePage('/');})
              }
            })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getUseOrdDtlNoGuide() {  // 유저 티켓 사용 API
      await store.dispatch('getUseOrdDtlNoGuide')
        .then(res => {
          if (res.success) {
            if (res.data != null) {
              this.movePage('/fo/guideSelect');
            }
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    ticketInfo() {
      this.movePage('/fo/ticketInfo');
    },
    goPage(){
      if (!this.isLoading) {
        if(this.first == 'first'){
          this.movePage('/')
        } else {
          this.prevPage()
        }
      }
    }
  }
}
</script>
